import React from "react";
import { Switch, Redirect } from "react-router-dom";
import RouteWithLayout from "./components/routeWithLayout/RouteWithLayout";
import MainView from "./layout/main/MainView";
import MinimalView from "./layout/minimal/MinimalView";
import DashboardView from "./layout/dashboard/DashboardView";

// imported Screens
// auths
import SignUp from "./views/auth/signUp/SignUp";
import Login from "./views/auth/login/Login";
import ForgotPassword from "./views/auth/forgotPassword/ForgotPassword";

// main
import Dashboard from "./views/dashboard/Dashboard";
import Chat from "./views/chat/Chat";
import Courses from "./views/courses/Courses";
import Followers from "./views/followers/Followers";
import Following from "./views/following/Following";
import Profile from "./views/profile/Profile";
import Search from "./views/search/Search";
import Category from "./views/category/Category";
import CourseDetail from "./views/courseDetail/CourseDetail";
import CreatePlaylist from "./views/createPlaylist/CreatePlaylist";
import OtherProfile from "./views/viewotherprofile/Profile";
import Createsession from "./views/session/Session";
import Streamplayer from "./views/streamplayer/Streamplayer";
import MyCalendar from "./views/calendar/Calendar";
import Searchresult from "./views/searchresult/Searchresult";

// landing page
import Home from "./views/home/Home";

const Routes = () => {
  return (
    <Switch>
      {/* <Redirect from="/" to="/login" /> */}
      {/* authentications */}
      <RouteWithLayout
        exact
        path="/login"
        component={Login}
        layout={MainView}
        access="public"
        restricted={true}
      />

      <RouteWithLayout
        exact
        path="/signUp"
        component={SignUp}
        layout={MainView}
        access="public"
        restricted={true}
      />

      <RouteWithLayout
        exact
        path="/"
        component={Home}
        layout={MinimalView}
        access="public"
      />

      <RouteWithLayout
        exact
        path="/forgot-password"
        component={ForgotPassword}
        layout={MainView}
        access="public"
        restricted={true}
      />
      {/* Dashboard */}
      <RouteWithLayout
        exact
        path="/dashboard"
        component={Dashboard}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/chat"
        component={Chat}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/courses"
        component={Courses}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/followers"
        component={Followers}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/following"
        component={Following}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/profile"
        component={Profile}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/view-profile/:id"
        component={OtherProfile}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/search/:key"
        component={Search}
        layout={MinimalView}
        access="public"
      />
      <RouteWithLayout
        exact
        path="/category/:name"
        component={Category}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/course-detail/:id"
        component={CourseDetail}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/create-playlist"
        component={CreatePlaylist}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/create-session"
        component={Createsession}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/live"
        component={Streamplayer}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/upcoming-classes"
        component={MyCalendar}
        layout={DashboardView}
        access="private"
      />
      <RouteWithLayout
        exact
        path="/search-result"
        component={Searchresult}
        layout={MinimalView}
        access="public"
      />
    </Switch>
  );
};
export default Routes;
